import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=564023bd&scoped=true&lang=pug&"
import script from "./Commands.vue?vue&type=script&lang=ts&"
export * from "./Commands.vue?vue&type=script&lang=ts&"
import style0 from "./Commands.vue?vue&type=style&index=0&id=564023bd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564023bd",
  null
  
)

export default component.exports